import "./AgilePersonalDashboardPage.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import { getImageCardUrl } from "@teams/cards";
import React from "react";

import { GenericSurveyTabPage } from "../../_shared/components/GenericSurveyTabPage";

export const AgilePersonalDashboardPage: React.FC = () => {
  return (
    <GenericSurveyTabPage
      loadingMessage="Loading Standups ..."
      scope="tenant"
      pageName="personal"
      showSchedules
      showSurveys
      hideCreate
      noResultsContent={<AgileDashboardNoResults />}
    />
  );
};

const AgileDashboardNoResults: React.FC = () => {
  return (
    <div className="agile-personal-dashboard-page__missing-container">
      <Flex hAlign="center">
        <div>
          <Text
            className="agile-personal-dashboard-page__no-survey"
            size="large"
            weight="bold"
            as="div"
            align="center"
          >
            Thanks for installing AgilePolly!
          </Text>
          <Text
            className="agile-personal-dashboard-page__no-survey"
            size="medium"
            weight="regular"
            as="div"
            align="center"
          >
            To get started with a standup, please add the AgilePolly tab to the channel you'd like
            to run standups in. Instructions in this short video:
          </Text>

          <div className="agile-personal-dashboard-page__missing-item-image">
            <img src={getImageCardUrl("GETTING_STARTED", "agile")} alt="Add the AgilePolly Tab" />
          </div>

          <Text
            className="agile-personal-dashboard-page__no-survey"
            size="medium"
            weight="regular"
            as="div"
            align="center"
          >
            If you have additional questions, please visit the help center
          </Text>
        </div>
      </Flex>
    </div>
  );
};
